import React from "react";
import { Outlet } from "react-router-dom";
import clsx from "clsx";

import { View } from "../components/base";
import { Icon } from "../components/base/Icon";
import { RequireAuth } from "../components/auth/RequireAuth";
import { LeftNavbar, SidebarSection } from "../components/LeftNavbar";
import { useAuth } from "../hooks/useAuth";
import { CommandPaletteProvider, CommandPalette } from "../components/CommandPalette";

export const AdminLayout = () => {
  const { isAdmin } = useAuth();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = React.useState(() => {
    const saved = localStorage.getItem("sidebarCollapsed");
    return saved !== null ? JSON.parse(saved) : false;
  });

  // Save to localStorage whenever collapsed state changes
  React.useEffect(() => {
    localStorage.setItem("sidebarCollapsed", JSON.stringify(isSidebarCollapsed));
  }, [isSidebarCollapsed]);

  const adminSections: SidebarSection[] = [
    {
      title: "Admin",
      links: [
        { label: "Users", to: "/admin/users" },
        { label: "Organizations", to: "/admin/organizations" },
        { label: "Templates", to: "/admin/templates" },
      ],
    },
    {
      // workflow order: curate a dataset, train a job on it, deploy it, evaluate the deployment, then release it to a name
      title: "Fine-Tuning",
      links: [
        { label: "Datasets", to: "/admin/fine-tuning-datasets" },
        { label: "Jobs", to: "/admin/fine-tuning-jobs" },
        { label: "Deployments", to: "/admin/fine-tuning-deployments" },
        { label: "Evals", to: "/admin/fine-tuning-evals" },
        { label: "Models", to: "/admin/fine-tuning-models" },
      ],
    },
    {
      title: "Platform",
      links: [
        { label: "Agents", to: "/agents" },
        { label: "Resources", to: "/resources" },
      ],
    },
  ];

  return (
    <CommandPaletteProvider>
      <RequireAuth requireAdmin>
        <View className="flex h-screen bg-gray-50 dark:bg-black">
          <LeftNavbar
            sections={adminSections}
            isOpen={isMobileMenuOpen}
            onClose={() => setIsMobileMenuOpen(false)}
            isCollapsed={isSidebarCollapsed}
            onToggleCollapse={() => setIsSidebarCollapsed(!isSidebarCollapsed)}
          />
          <View className={clsx("flex flex-col flex-1 overflow-hidden mr-3", isSidebarCollapsed ? "lg:ml-[60px]" : "lg:ml-[220px]")}>
            {/* Mobile hamburger button */}
            <button
              type="button"
              onClick={() => setIsMobileMenuOpen(true)}
              className="hamburger-button lg:hidden absolute top-4 left-4 z-40 h-10 w-10 rounded-lg bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors flex items-center justify-center shadow-sm"
            >
              <Icon
                name="menu"
                size={18}
                className="text-gray-500 dark:text-gray-400"
              />
            </button>
            <View className="flex flex-1 overflow-y-auto bg-gray-50 dark:bg-black">
              <Outlet />
            </View>
          </View>
        </View>
      </RequireAuth>
      <CommandPalette />
    </CommandPaletteProvider>
  );
};
